$(() => {
  $(".tab_name").eq(0).addClass("active");
  let vT = $(".tab_name.active").attr("data-name");
  //$('[data-style="'+vT+'"]').eq(0).find('input').trigger('click');
  //$('[data-value="'+vT+'"]').closest('.swatch__option').find('input').trigger('click');

  $(".swatch__options").each(function () {
    let v = $(this).find("input:checked").val();

    if ($('.tab_name[data-name="' + v + '"').attr("data-name") == v) {
      $(".tab_name").removeClass("active");
      $('.product_section .tab_name[data-name="' + v + '"]').addClass("active");
      $('[data-value="' + v + '"]')
        .closest(".swatch__option")
        .find("input")
        .trigger("click");
      $("[data-style]").hide();
      $('[data-style="' + v + '"]').show();
    }

    $('.my-size-option[value="' + v + '"]').prop("checked", true);
  });

  $(document).on("click", ".tab_name", function () {
    $(".tab_name").removeClass("active");
    $(this).addClass("active");
    let v = $(this).attr("data-name");
    $('[data-value="' + v + '"]')
      .closest(".swatch__option")
      .find("input")
      .trigger("click");

    $('[data-style="' + v + '"]').show();
    $('[data-style="' + v + '"]')
      .eq(0)
      .find("input")
      .trigger("click");
  });
  $(document).on("change", ".my-size-option", function () {
    let valueInputChange = $(this).val();
    $('input[value="' + valueInputChange + '"]').trigger("click");
  });
});
$(window).on("load", function () {
  // Sayfaya gelen URL'yi al
  var currentUrl = window.location.href;

  // "variant=" den sonraki değeri almak için URL'yi parçala
  var variantId = currentUrl.split("variant=")[1];

  // Eğer "variant" parametresi varsa
  if (variantId) {
    // "variantId" ile eşleşen id'ye sahip label'i bul
    var label = $("#" + variantId);

    // Eğer label bulunursa, ona istenen özellikleri ekle
    if (label.length) {
      label.css({
        "border-color": "#873531", // Örnek olarak bir arka plan rengi ekler
        "border-width": "medium",
      });
    }
  }
});
